import { IconProps } from "../../types/utils";

const NoPhotosIcon = ({ color, dimension, ...props }: IconProps) => (
  <svg
    width={dimension || 48}
    height={dimension || 48}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask id="path-1-inside-1_3947_24243" fill="white">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 21.4627C15.1945 20.7698 16 19.4767 16 18V16H18C20.2046 16 22 14.2046 22 12C22 11.2721 21.8043 10.5888 21.4627 10H29.155C29.6952 10 30.2125 10.2185 30.589 10.6058L36 16.1714L41.3936 21.4109C41.7813 21.7875 42 22.305 42 22.8455V42C42 43.1046 41.1046 44 40 44H16C14.8954 44 14 43.1046 14 42V21.4627Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 21.4627C15.1945 20.7698 16 19.4767 16 18V16H18C20.2046 16 22 14.2046 22 12C22 11.2721 21.8043 10.5888 21.4627 10H29.155C29.6952 10 30.2125 10.2185 30.589 10.6058L36 16.1714L41.3936 21.4109C41.7813 21.7875 42 22.305 42 22.8455V42C42 43.1046 41.1046 44 40 44H16C14.8954 44 14 43.1046 14 42V21.4627Z"
      fill={color || "#CBD1D9"}
    />
    <path
      d="M14 21.4627L12.9964 19.7327L12 20.3108V21.4627H14ZM16 16V14H14V16H16ZM21.4627 10V8H17.9903L19.7327 11.0036L21.4627 10ZM30.589 10.6058L32.023 9.21169V9.21169L30.589 10.6058ZM36 16.1714L34.566 17.5656L34.5859 17.5861L34.6064 17.606L36 16.1714ZM41.3936 21.4109L40 22.8455L40 22.8455L41.3936 21.4109ZM15.0036 23.1927C16.7869 22.1582 18 20.2215 18 18H14C14 18.7319 13.6021 19.3814 12.9964 19.7327L15.0036 23.1927ZM18 18V16H14V18H18ZM16 18H18V14H16V18ZM18 18C21.3091 18 24 15.3091 24 12H20C20 13.1 19.1 14 18 14V18ZM24 12C24 10.9091 23.7057 9.88085 23.1927 8.99641L19.7327 11.0036C19.9028 11.2967 20 11.6351 20 12H24ZM29.155 8H21.4627V12H29.155V8ZM32.023 9.21169C31.2699 8.43704 30.2354 8 29.155 8V12L29.155 12L32.023 9.21169ZM37.434 14.7773L32.023 9.21169L29.155 12L34.566 17.5656L37.434 14.7773ZM42.7871 19.9763L37.3936 14.7369L34.6064 17.606L40 22.8455L42.7871 19.9763ZM44 22.8455C44 21.7645 43.5625 20.7295 42.7871 19.9763L40 22.8455L40 22.8455H44ZM44 42V22.8455H40V42H44ZM40 46C42.2091 46 44 44.2091 44 42H40V46ZM16 46H40V42H16V46ZM12 42C12 44.2091 13.7909 46 16 46V42H16H12ZM12 21.4627V42H16V21.4627H12Z"
      fill={color || "#CBD1D9"}
      mask="url(#path-1-inside-1_3947_24243)"
    />
    <path
      d="M9.5 18C9.5 19.3761 10.6239 20.5 12 20.5C13.3761 20.5 14.5 19.3761 14.5 18V14.5H18C19.3761 14.5 20.5 13.3761 20.5 12C20.5 10.6239 19.3761 9.5 18 9.5H14.5V6C14.5 4.62386 13.3761 3.5 12 3.5C10.6239 3.5 9.5 4.62386 9.5 6V9.5H6C4.62386 9.5 3.5 10.6239 3.5 12C3.5 13.3761 4.62386 14.5 6 14.5H9.5V18Z"
      fill={color || "#CBD1D9"}
      stroke="white"
    />
  </svg>
);

export default NoPhotosIcon;
